/* PARWIN flash sale: PDP countdown box + MaxAir card badge (with % + live timer) */
(function () {
  if (window.__parwinFlash) return; window.__parwinFlash = true;
  var HANDLE = 'maxair-luxe-styler-1-0';
  var CFG = { code: 'MAXAIRJFTC20', text: '⚡ Flash deal — extra 20% off', mins: 9 };

  function sessionEnd() {
    var key = 'ppflash_' + CFG.code, now = Date.now(), end;
    try { end = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (e) { end = 0; }
    if (!end) { end = now + CFG.mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} }
    return end;
  }
  function fmt(d) { function p(n){return (n<10?'0':'')+n;} return p(Math.floor(d/60000)) + ':' + p(Math.floor(d % 60000 / 1000)); }

  function styles() {
    if (document.getElementById('pp-flash-style')) return;
    var st = document.createElement('style'); st.id = 'pp-flash-style';
    st.textContent =
      '.pp-flash{border:1.5px solid #d81e1e;background:#fdecec;border-radius:12px;padding:11px 13px;margin:14px 0;font-family:var(--font-body--family,inherit)}'
    + '.pp-flash__top{display:flex;align-items:center;gap:10px;flex-wrap:wrap}'
    + '.pp-flash__text{font-weight:700;color:#b01818;font-size:1rem;flex:1;min-width:150px}'
    + '.pp-flash__timer{font-variant-numeric:tabular-nums;font-weight:700;color:#fff;background:#d81e1e;border-radius:6px;padding:3px 10px;font-size:1rem;letter-spacing:.5px}'
    + '.pp-flash__code{display:flex;align-items:center;gap:8px;width:100%;margin-top:9px;background:#fff;border:1px dashed #d81e1e;border-radius:8px;padding:8px 12px;cursor:pointer}'
    + '.pp-flash__label{color:#8a8a8a;font-size:.85rem}.pp-flash__value{font-weight:800;letter-spacing:1px;color:#1a1a1a;font-size:1.05rem}'
    + '.pp-flash__copy{margin-left:auto;color:#d81e1e;font-weight:600;font-size:.8rem;white-space:nowrap}.pp-flash--ended{display:none}'
    /* card badge: ~20% bigger than before + % + timer */
    + '.pp-flash-badge{display:inline-flex;align-items:center;gap:5px;background:#d81e1e;color:#fff;font-weight:700;font-size:.86rem;line-height:1;'
    +   'padding:6px 11px;border-radius:var(--badge-border-radius,100px);letter-spacing:.2px;white-space:nowrap;box-shadow:0 1px 3px rgba(0,0,0,.18)}'
    + '.pp-flash-badge__t{font-variant-numeric:tabular-nums;background:rgba(0,0,0,.18);border-radius:5px;padding:2px 6px;margin-left:2px}';
    document.head.appendChild(st);
  }

  function pdpFlash() {
    if (location.pathname.indexOf('/products/' + HANDLE) === -1) return;
    if (document.querySelector('[data-pp-flash]')) return;
    var host = document.querySelector('variant-picker') || document.querySelector('.variant-option');
    if (!host) return;
    if (host.tagName !== 'VARIANT-PICKER' && host.closest('variant-picker')) host = host.closest('variant-picker');
    host.insertAdjacentHTML('afterend',
      '<div class="pp-flash" data-pp-flash><div class="pp-flash__top"><span class="pp-flash__text">' + CFG.text +
      '</span><span class="pp-flash__timer" data-pp-timer>--:--</span></div>' +
      '<button type="button" class="pp-flash__code" data-pp-code="' + CFG.code + '" aria-label="Copy code ' + CFG.code +
      '"><span class="pp-flash__label">Use code</span><span class="pp-flash__value">' + CFG.code +
      '</span><span class="pp-flash__copy" data-pp-copylabel>Tap to copy</span></button></div>');
    var c = document.querySelector('[data-pp-flash] [data-pp-code]');
    c.addEventListener('click', function () {
      var v = c.getAttribute('data-pp-code'), l = c.querySelector('[data-pp-copylabel]');
      function ok(){ var s=l.textContent; l.textContent='Copied ✓'; setTimeout(function(){l.textContent=s;},1500); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(ok, ok);
      else { try { var x=document.createElement('textarea'); x.value=v; document.body.appendChild(x); x.select(); document.execCommand('copy'); document.body.removeChild(x); ok(); } catch(e){} }
    });
  }

  function cardBadges() {
    document.querySelectorAll('a[href*="/products/' + HANDLE + '"]').forEach(function (a) {
      var card = a.closest('.product-card'); if (!card || card.__ppbadge) return;
      var badges = card.querySelector('.product-badges');
      if (!badges) { var gal = card.querySelector('.card-gallery'); if (!gal) return; badges = document.createElement('div'); badges.className = 'product-badges product-badges--top-left'; gal.insertBefore(badges, gal.firstChild); }
      if (!badges.querySelector('.pp-flash-badge')) {
        var b = document.createElement('span'); b.className = 'pp-flash-badge';
        b.innerHTML = '⚡ Flash deal: 20% off <span class="pp-flash-badge__t" data-ppcardtimer>--:--</span>';
        badges.insertBefore(b, badges.firstChild);
      }
      card.__ppbadge = 1;
    });
  }

  var END, ti;
  function tick() {
    var d = END - Date.now(), expired = d <= 0, txt = expired ? '00:00' : fmt(d);
    document.querySelectorAll('[data-pp-timer],[data-ppcardtimer]').forEach(function (t) { t.textContent = txt; });
    if (expired) {
      document.querySelectorAll('[data-pp-flash]').forEach(function (x) { x.classList.add('pp-flash--ended'); });
      document.querySelectorAll('.pp-flash-badge').forEach(function (x) { x.style.display = 'none'; });
      if (ti) clearInterval(ti);
    }
  }
  function run() { styles(); END = sessionEnd(); pdpFlash(); cardBadges(); tick(); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  ti = setInterval(tick, 1000);
  var n = 0, lazy = setInterval(function () { cardBadges(); if (++n >= 5) clearInterval(lazy); }, 1200);
})();
